import { motion } from "framer-motion";
import { MapPin, CalendarDays } from "lucide-react";
import { fmtDateTime } from "@/lib/api";
import { SampleBadge } from "@/components/SampleBadge";

export const EventCard = ({ e, onOpen, i = 0, tall = false }) => (
  <motion.button
    onClick={() => onOpen?.(e)}
    data-testid={`event-card-${e.id}`}
    initial={{ opacity: 0.001, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.08 }}
    className="group text-left w-full rounded-2xl border border-[#2A1240]/10 bg-[#FFFFFF] overflow-hidden hover:border-[#E0218A]/40 transition-colors"
  >
    <div className={`relative overflow-hidden ${tall ? "aspect-[4/5]" : "aspect-[16/10]"}`}>
      {e.image_url ? (
        <img src={e.image_url} alt={e.title} loading="lazy"
          className="absolute inset-0 h-full w-full object-cover scale-[1.02] group-hover:scale-110 transition-transform duration-[1400ms] ease-[cubic-bezier(.16,1,.3,1)]" />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-[#FBE9F3] to-[#FFF7FB]" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#FFF7FB] via-[#FFF7FB]/20 to-transparent" />
      <span className={`absolute top-4 left-4 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] ${e.type === "partnership" ? "bg-[#E0218A] text-white" : "bg-[#2A1240] text-white"}`}>
        {e.type}
      </span>
      {e.metrics && (
        <span className="absolute top-4 right-4 rounded-full glass px-3 py-1 font-mono text-xs text-emerald-300">ROI {e.metrics.roi}%</span>
      )}
    </div>
    <div className="p-5">
      <p className="text-xs text-slate-400 flex items-center gap-2"><SampleBadge show={e.sample} testid={`event-sample-${e.id}`} />{e.company_name}</p>
      <h3 className="mt-1 font-display text-xl text-[#2A1240] leading-snug group-hover:text-[#8E2BC4] transition-colors">{e.title}</h3>
      <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-300">
        <span className="flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5 text-[#E0218A]" />{fmtDateTime(e.starts_at)}</span>
        {e.location && <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-[#E0218A]" />{e.location}</span>}
      </div>
    </div>
  </motion.button>
);
